import React from 'react';
import { navigateTo } from '../utils/navigation';

// Pestañas de la sección Facturas: las que emitimos y las que nos emiten los proveedores (los CFE
// que llegan al facturador). Van en pantallas separadas porque las dos grillas comparten ids.
const TABS = [
    { path: '/invoices', label: 'Emitidas' },
    { path: '/receivedInvoices', label: 'Recibidas' },
];

export default function FacturasTabs({ active }) {
    return (
        <ul className="nav nav-tabs mb-3">
            {TABS.map((t) => (
                <li className="nav-item" key={t.path}>
                    <button type="button"
                        className={`nav-link ${active === t.path ? 'active' : ''}`}
                        style={{ background: 'none', border: 0, borderBottom: active === t.path ? '2px solid #007bff' : '2px solid transparent' }}
                        onClick={() => { if (active !== t.path) navigateTo(t.path); }}>
                        {t.label}
                    </button>
                </li>
            ))}
        </ul>
    );
}
